<template>
    <Head title="Manage Roles" />

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="py-8 max-w-7xl mx-auto grid gap-4">
            <div class="p-6 bg-white border border-gray-200 sm:rounded-lg">
                <div class="flex flex-row justify-between">
                    <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight">
                        Manage Roles
                    </h3>
                    <ButtonSecondary :href="route('settings.roles.create')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-2" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        <span>
                            Create
                        </span>
                    </ButtonSecondary>
                </div>

                <div class="grid gap-4 grid-cols-12 border-b mt-6 pb-2 font-semibold">
                    <div class="col-span-4">Name</div>
                    <div class="col-span-7">Comment</div>
                </div>
                <div class="grid gap-4 grid-cols-12 border-b py-2" v-for="role in roles.data" :key="role.id">
                    <Link :href="route('settings.roles.edit', role.id)" class="col-span-4">{{ role.name }}</Link>
                    <Link :href="route('settings.roles.edit', role.id)" class="col-span-7">{{ role.comment }}</Link>
                    <Link :href="route('settings.roles.edit', role.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="block m-auto h-full">
                            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </Link>
                </div>
                <Pagination class="mt-6" :links="roles.links" />
            </div>
        </div>
    </AuthenticatedLayout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import Pagination from "@/Components/Pagination";
import Button from "@/Components/Button";
import ButtonSecondary from "@/Components/ButtonSecondary";
import moment from 'moment';

export default {
    components: {
        Head,
        Link,
        AuthenticatedLayout,
        NavigationSettings,
        Pagination,
        Button,
        ButtonSecondary,
    },
    props: {
        roles: Object,
    },
    methods: {
        moment
    },
}
</script>
